module.exports = __webpack_public_path__ + "img/dashboard2-white.9d2385b0.svg";